<template>
  <v-container fluid class="hide-for-inspection-sheet">
    <v-card elevation="1">
      <v-card-text>
        <div class="d-block d-md-flex align-end">
          <v-dialog max-width="600" v-model="settingsOpen">
            <template #activator="{on}">
              <v-btn v-on="on" depressed small color="primary">
                <v-icon class="mr-1" small>mdi-cog</v-icon>Settings
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="pt-5 ">
                <div>
                  <!--Inspector Filter-->
                  <v-select
                      :items="allInspectors"
                      :menu-props="{ maxHeight: '300' }"
                      :value="checkedInspectors"
                      chips
                      class="mb-2"
                      hide-details
                      item-text="display_name"
                      item-value="id"
                      label="Select visible inspectors"
                      multiple
                      persistent-hint
                      @change="checkedInspectors = $event"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index <= 2">
                        <span>{{ item.display_name }}</span>
                      </v-chip>
                      <span
                          v-if="index === 3"
                          class="grey--text caption"
                      >
                      (+{{ selectedInspectors.length - 3 }} more)`
                    </span>
                    </template>
                  </v-select>
                  <v-btn
                      class="mr-2"
                      x-small
                      @click="selectAll"
                  >
                    all
                  </v-btn>
                  <v-btn
                      class="mr-2"
                      x-small
                      @click="selectNone"
                  >
                    none
                  </v-btn>
                  <v-btn
                      x-small
                      @click="selectMe"
                  >
                    Just Me
                  </v-btn>
                </div>
                <v-select
                    v-model="increments"
                    :items="[{text: '15 minutes', value: 15}, {text: '30 minutes', value: 30},{text: '1 hour', value: 60}]"
                    class="my-5"
                    dense
                    filled
                    hide-details
                    label="Calendar Increments"
                ></v-select>
                <v-select
                    v-model="currentView"
                    :items="viewOptions"
                    class="mt-3"
                    dense
                    filled
                    hide-details
                    label="Calendar View"
                ></v-select>
                <v-btn-toggle
                    v-model="viewAvailability"
                    class="mt-3"
                    dense
                    mandatory
                >
                  <v-btn :value="false" small>
                    Hide Availability
                  </v-btn>
                  <v-btn :value="true" small>
                    Show Availability
                  </v-btn>
                </v-btn-toggle>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="saveSettings"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div class="flex-grow-1">
            <div class="d-block d-sm-flex flex-column justify-end align-end">
              <!--Color Picker-->
              <div class="ml-sm-3 mt-3 mt-sm-0 d-none">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                    >
                      <v-icon small class="mr-1">mdi-eyedropper-variant</v-icon> Color Picker
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-select
                          v-model="colorPickerInspector"
                          :items="allInspectors"
                          :menu-props="{ maxHeight: '300' }"
                          item-text="display_name"
                          item-value="id"
                          label="Inspector"
                          persistent-hint
                      >
                      </v-select>
                      <v-color-picker
                          :swatches="swatches"
                          v-model="selectedColor"
                          hide-canvas
                          hide-inputs
                          hide-mode-switch
                          mode="rgba"
                          show-swatches
                          swatches-max-height="175"
                          width="350"
                      ></v-color-picker>
                      <v-btn
                          @click="setInspectorColor"
                          color="success"
                          small
                          block
                      >Save</v-btn>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
              <div class="mt-2">
                <span class="text-caption">Legend: </span>
                <v-chip label v-bind:[size]="true" dark color="#0000FF" class="font-weight-medium px-2">
                  Appointment
                </v-chip>
                <v-chip label v-bind:[size]="true" light color="#C8E1EB" class="ml-1 font-weight-medium px-2">
                  Available
                </v-chip>
                <v-chip label v-bind:[size]="true" light color="#f5BE6B" class="ml-1 font-weight-medium px-2">
                  Not Available
                </v-chip>
                <v-chip label v-bind:[size]="true" light color="#FFFF00" class="ml-1 font-weight-medium px-2">
                  Note
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <app-scheduler-component
          v-model="currentView"
          :current-view="currentView"
          :end-time="end_hour"
          :increments="increments"
          :inspector-colors="inspectorColors"
          :inspectors="selectedInspectors"
          :start-time="start_hour"
          :view-availability="viewAvailability"
      ></app-scheduler-component>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
const AppSchedulerComponent = () => import('./AppSchedulerComponent')

export default {
  name: 'AppScheduler',
  components: {AppSchedulerComponent},
  data() {
    return {
      allInspectors: [],
      checkedInspectors: [],
      increments: 15,
      viewAvailability: true,
      currentView: 'Day',
      viewOptions: ['Day', 'Week', 'Month', 'TimelineDay', 'TimelineWeek', 'TimelineMonth'],
      colorPickerInspector: null,
      selectedColor: '#AD1457FF',
      inspectorColors: {},
      start_hour: '09:00',
      end_hour: '17:00',
      swatches: [
        ['#AD1457FF', '#F4511EFF', '#E4C441FF', '#0B8043FF'],
        ['#3F51B5FF', '#8E24AAFF', '#D81B60FF', '#EF6C00FF'],
        ['#C0CA33FF', '#009688FF', '#7986CBFF', '#795548FF'],
        ['#D50000FF', '#F09300FF', '#7CB342FF', '#039BE5FF'],
        ['#B39DDBFF', '#616161FF', '#E67C73FF', '#F6BF26FF'],
        ['#33B679FF', '#4285F4FF', '#9E69AFFF', '#A79B8EFF'],
      ],
      settingsOpen: false,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    size() {
      return this.$vuetify.breakpoint.smAndDown ? 'x-small' : 'small'
    },
    selectedInspectors() {
      return this.allInspectors.filter(item => this.checkedInspectors.includes(item.id))
    },
    selectedHexColor() {
      return this.selectedColor.hexa || this.selectedColor
    },
  },
  methods: {
    ...mapActions(['putInspectorColors', 'retrieveInspectorColors', 'retrieveInspectors', 'putSchedulerSettings']),
    ...mapMutations(['setShowSnackbar', 'setSnackbarMsg', 'setSnackbarColor', 'setLoggedIn']),
    selectAll() {
      this.checkedInspectors = this.allInspectors.map(item => item.id)
    },
    selectNone() {
      this.checkedInspectors = []
    },
    selectMe() {
      this.checkedInspectors = [this.getUser.id]
    },
    setInspectorColor() {
      this
          .putInspectorColors({
            inspectorId: this.colorPickerInspector,
            color: this.selectedHexColor
          })
          .then(response => {
            this.inspectorColors = response.data
            document.querySelector('#scheduler').ej2_instances[0].refreshEvents()
          })
    },
    async getInspectorsAndColors() {
      this.inspectorColors = (await this.retrieveInspectorColors()).data
      this.allInspectors = (await this.retrieveInspectors()).data
      this.colorPickerInspector = this.allInspectors[0].id
    },
    getErrorMessage(error) {
      switch (true) {
        case error.response:
          return error.response.data.message
        case error.request:
          return 'Network error. Please try again.'
      }
      return 'Unknown error occurred. Please try again.'
    },
    saveSettings() {
      // Save the current scheduler view and selected inspectors
      this.setShowSnackbar(true)
      this.setSnackbarMsg('Saving settings...')
      this.setSnackbarColor('primary')
      const payload = {
        selected: {
          inspectors: this.checkedInspectors,
          view: this.currentView,
          increments: this.increments,
          view_availability: this.viewAvailability,
        }
      };
      this.putSchedulerSettings(payload)
          .then(response => {
            this.setLoggedIn(response.data)
            this.setSnackbarMsg('Settings saved.')
            this.setSnackbarColor('success')
            this.settingsOpen = false
          })
    },
  },
  watch: {
    colorPickerInspector() {
      this.selectedColor = this.inspectorColors[this.colorPickerInspector]
    }
  },
  mounted() {
    this.getInspectorsAndColors()
    this.start_hour = this.getUser.start_hour
    this.end_hour = this.getUser.end_hour
    this.checkedInspectors = this.getUser.myacc_settings?.selected?.inspectors || [this.getUser.id]
    this.increments = this.getUser.myacc_settings?.selected?.increments || 15
    this.currentView = this.getUser.myacc_settings?.selected?.view ?? 'Day'
    this.viewAvailability = this.getUser.myacc_settings?.selected?.view_availability ?? true
  },
}
</script>